var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TagsDropdown',_vm._g(_vm._b({attrs:{"options":_vm.countryOptions},scopedSlots:_vm._u([{key:"preValue",fn:function(ref){
var option = ref.option;
return [(option.id)?_c('CountryFlag',{staticClass:"country-flag",attrs:{"countryCode":option.id.toLowerCase()}}):_vm._e()]}},{key:"preOptionInner",fn:function(ref){
var option = ref.option;
return [(option.id && !option.isHeader)?_c('CountryFlag',{staticClass:"country-flag option",attrs:{"countryCode":option.id.toLowerCase()}}):_vm._e()]}}])},'TagsDropdown',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }